import $fn from '@/utils/fn';
import {
    getUserInfo,
    getMenu,
    DetailList
} from '@/req/user';
import { tagList, withRank, byRand } from '@/req/home'
export default {
    namespaced: true,
    state: {
        // 版本id
        versions: "",
        // 特色标签
        tag: "",
        // 人气类型
        type: "",
        // 页码
        page: "",
        // 标签信息
        featurelist: [],
        // 版本信息
        versionList: [],
        // list组件数据
        listData: [],
        // 排行页数据
        rankData: []
    },
    // getters:{},
    mutations: {
        setVersions(state: { versions: any; }, obj: any) {
            state.versions = obj
        },
        setFeaturelist(state: { featurelist: any; }, obj: any) {
            state.featurelist = obj;
        },
        setVersionList(state: { versionList: any; }, obj: any) {
            state.versionList = obj;
        },
        setWithRank(state: { rankData: any; }, obj: any) {
            state.rankData = obj;
        },
    },
    actions: {
        async updateVerison({
            commit,
            // tslint:disable-next-line:align
        }, verisons) {
            commit('setVersions', verisons)
        },
        async getWithRank({
            commit,
            rootState
        }) {
            const obj = {
                token: $fn.cookies.getToken(),
                versionid: rootState.withRank.versions,
                tag: rootState.withRank.tag,
                type: rootState.withRank.type,
                page: rootState.withRank.page,
                size: 10

            }
            const res = await withRank(obj);
            commit('setWithRank', res.data.game_info);
        },
        async getByRand({
            commit,
            rootState
        }) {
            const obj = {
                token: $fn.cookies.getToken(),
                versionid: rootState.withRank.versions,
                tag: rootState.withRank.tag,
                type: rootState.withRank.type
            }
            const res = await byRand(obj);
            commit('setWithRank', res.data.rankList);
        },
        // async initDetailList({ commit }) {
        //     this.getPlatform(commit);
        //     this.getGame(commit)
        //     this.getGametype(commit)
        //     this.getGroup(commit)
        //     this.getServerlist(commit)
        //     this.getSpacetype(commit)
        // },

        /*****************************************  ********************************/
        // 设置当前用户角色
        async updateInfo({
            commit,
        }) {
            try {
                // const res = await getUserInfo()
                // if ($fn.n(res.code) === 200) {
                //     commit('setInfo', res.data)
                // } else {
                //     if (window.location.href.indexOf('/login') === -1) {
                //         window.App.$router.push({
                //             path: '/login',
                //         })
                //     }
                // }
            } catch (err) {
                if (window.location.href.indexOf('/login') === -1) {
                    window.App.$router.push({
                        path: '/login',
                    })
                }
            }
        },
    },
}
